<template>
  <div class="setting-main-container">
        <div class="card setting-card">
            <div class="page-header d-flex justify-content-between">
                <div>
                <h3 class="page-title">
                    {{ $t('profile.documents.documents') }}
                </h3>

                </div>
                <base-button
                    outline
                    class="add-new-tax"
                    color="theme"
                    @click="addDocumentModel"
                >
                    {{ $t('profile.documents.add_new') }}
                </base-button>
            </div>

            <table-component
              ref="documentData"
              :show-filter="false"
              :data="profileDocuments"
              table-class="table tax-table"
              class="mb-3"

            >
            <table-column
              :label="$t('profile.documents.document_type')"
               show="documentType.name"
            />
            <table-column
              :label="$t('profile.documents.document_name')"
               show="name"
            />
            <table-column
              :sortable="false"
              :filterable="false"
              cell-class="action-dropdown"
            >
            <template slot-scope="row">
                <span> {{ $t('customers.action') }} </span>
                <v-dropdown>
                    <a slot="activator" href="#"><dot-icon /></a>
                    <v-dropdown-item >
                        <div class="dropdown-item" @click="documentNote(row)" >
                            <font-awesome-icon :icon="['fa', 'sticky-note']" class="dropdown-item-icon" />
                            {{ $t('general.note') }}
                        </div>
                    </v-dropdown-item>
                    <v-dropdown-item>
                        <div class="dropdown-item">
                            <a  :href="row.path"  target="_blank" v-if="row.path">
                            <font-awesome-icon icon="eye" class="dropdown-item-icon" />
                            {{ $t('general.view') }}
                            </a>
                        </div>
                    </v-dropdown-item>
                    <v-dropdown-item >
                        <div class="dropdown-item" @click="deleteDocument(row)" >
                            <font-awesome-icon :icon="['fas', 'trash']" class="dropdown-item-icon" />
                            {{ $t('general.delete') }}
                        </div>
                    </v-dropdown-item>
                </v-dropdown>
            </template>
            </table-column>

        </table-component>
      </div>
    </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
const { required, maxLength, alpha,minLength,email } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
        selectedCompany:null,
    }
  },
  computed: {
    ...mapGetters('documentType', [
      'profileDocuments'
    ]),
  },
  watch: {
  },
  validations: {
     formData: {}
  },
  created() {},
  mounted(){},
  methods: {
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('documentType', [
      'addCompanyAttachment',
      'fetchCompanyAttachments',
      'deleteCompanyAttachment'
    ]),
    addDocumentModel(){
       this.openModal({
        'title': 'Add Document',
        'componentName': 'DocumentModal',
      })
      this.$refs.documentData.refresh()
    },
    editStakeHolder(data){
       this.openModal({
        'title': 'Edit Owner/Partner/Director',
        'componentName': 'StakeholderModal',
        'id': data.id,
        'data': data
      })
      this.$refs.documentData.refresh()
    },
    documentNote(data){
        this.openModal({
        'title': 'Document Note',
        'componentName': 'DocumentNoteModal',
        'id': data.id,
        'data': data
      })
    },
    async deleteDocument(row){

        swal({
        title: this.$t('general.are_you_sure'),
        text: this.$tc('profile.documents.confirm_document_delete'),
        icon: '/assets/icon/trash-solid.svg',
        buttons: true,
        dangerMode: true
      }).then(async (willDelete) => {
        if (willDelete) {
           let data={
            'attachment_id':row.id,
            'id': localStorage.getItem('selectedCompany')
            }
        let res =  await this.deleteCompanyAttachment(data)
        if(res.data.result=='success'){
            window.toastr['success'](this.$tc('profile.documents.delete_document_message'))
            this.Attachments();
        }else if (res.data.error) {
            window.toastr['error'](res.data.message)
          }
        }
      })
    },
    async Attachments(){
        const data = {
            id: localStorage.getItem('selectedCompany')
        }
        let response = await this.fetchCompanyAttachments(data)
        this.isRequestOngoing = false
    },
  }
}
</script>
